/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import '../../../../../../../App.css'
import {useNavigate} from 'react-router-dom'
import useLocalStorageFetch from '../../../../../../../hooks/localStorageFetch'
import {LoadingSpinner} from '../../../../../../../_ePulse/layout/components/LoadingSpinner'
import {CANCEL_APPOINTMENT} from '../../../../GraphQLQueries/Dashboard'
import clsx from 'clsx'
import {useGetDateTimeFormat} from '../../../../../../../data/config'
import useMutationApi from '../../../../../../../hooks/useMutation'
import {toast} from 'react-toastify'
import {success} from '../../../../../../../data/Status/success'

const RXListingHeader = (props: any) => {
  const navigate = useNavigate()
  const {role} = useLocalStorageFetch()
  const [mainTabs, setMainTabs] = useState(props.mainTab)
  const [isLoading, setLoading] = useState(false)
  const [modalState, setmodalState] = useState(false)

  const getTimeZone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  }

  const onHandleclick = (appointment: any) => {
    navigate(`/${role}/rx_template/rx-on-fly`, {
      state: {
        appointmentId: appointment.id,
        patientData: {
          userId: appointment.patientId,
          firstName: appointment.firstName,
          lastName: appointment.lastName,
        },
      },
    })
  }

  const {
    createData,
    loading: cancelAppointmentLoading,
    error: cancelAppointmenterror,
    data: cancelAppointmentData,
  } = useMutationApi(CANCEL_APPOINTMENT)

  const onHandleCancelAppointment = async (appointment: any) => {
    try {
      setLoading(true)
      await createData({
        appointmentId: appointment.id,
        status: 'Cancelled',
      })
      toast.success(success.APPOINTMENT_CANCELED_SUCCESSFULLY)

      setmodalState(false)
      // setTimeout(() => {
      //   setLoading(false)
      //   navigate(`/${role}/dashboard`)
      // }, 2000)
    } catch (error) {
      setLoading(false)
    }
  }

  // useEffect(() => {
  //   if (data) {
  //     const res = data?.getDoctorAppointmentOnDateV2?.data
  //     let filterRes = []
  //     if (mainTabs === 'pending') {
  //       filterRes = res.filter((item: any) => item?.latestStatus === 'Confirmed')
  //     } else {
  //       filterRes = res.filter((item: any) => item?.latestStatus === 'Completed')
  //     }
  //     setList(filterRes)
  //     settotalPages(data?.getDoctorAppointmentOnDateV2?.totalPages)
  //     setpageNumber(data?.getDoctorAppointmentOnDateV2?.page)
  //   }
  // }, [data, mainTabs, loading])

  return (
    <div className='card card-xl-stretch'>
      {/* {modalState && (
        <div>
          <ToastMessageContainer />
          <Modal
            show={modalState}
            dialogClassName='ePulse-modal ePulse-modal-50w'
            onHide={() => setmodalState(false)}
            backdrop='static'
          >
            <Modal.Header closeButton>
              <span className='fs-3 fw-bold'>Cancel Appointment</span>
            </Modal.Header>
            <Modal.Body className='container'></Modal.Body>
            <div className='ePulse-modal-content'>
              <LoadingSpinner isLoading={loading} />
              <div className='bg-white rounded p-3 '>
                <span>Are you sure you want to cancel appointment?</span>
              </div>

              <div className='btn-row'>
                <button
                  className='ePulse-btn-primary'
                  type='button'
                  onClick={() => onHandleCancelAppointment(appointmentData)}
                >
                  Yes
                </button>
                <button
                  className='ePulse-btn-secondory ms-2'
                  type='button'
                  onClick={() => setmodalState(false)}
                >
                  No
                </button>
              </div>
            </div>
          </Modal>
        </div>
      )} */}

      <LoadingSpinner isLoading={cancelAppointmentLoading || isLoading} />
      {/* begin::Header */}

      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold text-dark'>
            Today's Appointments
            <span className='fw-normal fs-5'>({useGetDateTimeFormat(new Date())})</span>
          </span>
        </h3>
        <div className='filter-row-notification mb-0 pb-0'>
          <button
            className='rx-on-fly-button me-3 border border-1 border-light rounded '
            onClick={() => {
              props.refresh()
            }}
          >
            <img
              alt='refresh'
              style={{width: 15, height: 15, cursor: 'pointer'}}
              src={'/media/ePulse/icons/refresh_white.png'}
            />
          </button>

          <button
            className={
              mainTabs === 'Confirmed'
                ? clsx('ePulse-btn-secondory me-4')
                : 'ePulse-btn-selected-white text-dark me-4'
            }
            onClick={() => {
              setMainTabs('Confirmed')
              props.changeMainTab('Confirmed')
            }}
          >
            <span className='fs-6 '>Confirmed</span>
          </button>
          <button
            className={
              mainTabs === 'Completed'
                ? clsx('ePulse-btn-secondory')
                : 'ePulse-btn-selected-white text-dark'
            }
            onClick={() => {
              setMainTabs('Completed')
              props.changeMainTab('Completed')
              // refectchappointments({
              //   date: moment().format('YYYY-MM-DD'),
              //   timeZone: getTimeZone(),
              // })
              // handleRefetchCompleted()
            }}
          >
            <span className='fs-6 '>Completed</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export {RXListingHeader}
